import { SelectOption } from "../SelectOption";
import { AppColorVariant } from "../../theme/AppColorVariant";

export enum MigrationFlagStatus {
  UnResolved = "unresolved",
  Resolved = "resolved",
  Acknowledged = "acknowledged",
}

export const MigrationFlagStatusSelectOptions: SelectOption<MigrationFlagStatus>[] = [
  { id: MigrationFlagStatus.UnResolved, label: "Blocked", color: "danger" },
  { id: MigrationFlagStatus.Resolved, label: "Allowed", color: "lime" },
  { id: MigrationFlagStatus.Acknowledged, label: "Acknowledged", color: "yellow" },
];

export const MigrationFlagStatusIntLabels: Record<string, string> = {
  [1]: "Blocked",
  [2]: "Allowed",
  [3]: "Acknowledged",
};

/** Conflict status reuses MigrationFlagStatus over the wire but needs its own operator-facing labels/colors. */
export const ConflictStatusLabels: Record<MigrationFlagStatus, string> = {
  [MigrationFlagStatus.UnResolved]: "Unresolved",
  [MigrationFlagStatus.Resolved]: "Resolved",
  [MigrationFlagStatus.Acknowledged]: "Acknowledged",
};

export const ConflictStatusColors: Record<MigrationFlagStatus, AppColorVariant> = {
  [MigrationFlagStatus.UnResolved]: "danger",
  [MigrationFlagStatus.Resolved]: "success",
  [MigrationFlagStatus.Acknowledged]: "yellow",
};

/** Operator-facing explanation of each conflict status — shown in the legend and per-badge tooltips. */
export const ConflictStatusDescriptions: Record<MigrationFlagStatus, string> = {
  [MigrationFlagStatus.UnResolved]:
    "Still blocking the file from uploading until you resolve it.",
  [MigrationFlagStatus.Resolved]:
    "A decision was applied; the file un-blocks and re-queues for the client.",
  [MigrationFlagStatus.Acknowledged]:
    "Deliberately left as-is: the file stays out of upload and further conflicts on it are not reported. Pick another action to release it.",
};